import { createSlice } from '@reduxjs/toolkit';

export const fullUrlSlice = createSlice({
  name: 'fullUrl',
  initialState: '',
  reducers: {},
});

export const { reducer: fullUrlReducer } = fullUrlSlice;
